export var findLabelByDomainType = function findLabelByDomainType(domainType) {
  return function (label) {
    return (label === null || label === void 0 ? void 0 : label.productLabelDomain) === domainType;
  };
};
//# sourceMappingURL=findLabelByDomainType.js.map